/**
 * Waar `/` naartoe stuurt: wie alleen het adres van zijn organisatie intypt.
 *
 * Vroeger altijd naar het beheer, omdat er nog geen medewerkersfeed was (Stap 8). Die is er al lang,
 * en medewerkers en leden zijn veruit de grootste groep: zij kwamen op het aanmeldscherm van het
 * beheer, dat hun pincode niet kent (testrapport 28 okt., fout 13).
 *
 * - Een sessie van Master: naar Master.
 * - Al de rest naar de app. Met een sessie kom je meteen op je beginscherm; zonder sessie stuurt de
 *   poortwachter van `/app` je naar `/app/login`, nadat hij stil het refresh-cookie probeerde.
 *
 * Een beheerder heeft geen aparte "beheersessie": het beheer en de app delen dezelfde sessie van de
 * organisatie, en welke rechten iemand heeft, is pas na een extra verzoek bekend. Hij komt dus ook in
 * de app, en gaat via het menu onder zijn naam naar het beheer - of hij typt `/admin`, zoals de
 * handleiding zegt.
 *
 * De mobiele app laadt `/app` en komt hier niet langs.
 */
export function rootTarget(audience: 'tenant' | 'platform' | null | undefined): '/app' | '/master' {
  return audience === 'platform' ? '/master' : '/app';
}
